"use client";

import { useSyncExternalStore } from "react";
import { getCookie } from "@/shared/libs/utils";

export const AUTH_TOKEN_CHANGED_EVENT = "mdsafar:auth-token-changed";

function subscribe(callback: () => void) {
  window.addEventListener(AUTH_TOKEN_CHANGED_EVENT, callback);
  window.addEventListener("focus", callback);
  window.addEventListener("pageshow", callback);
  window.addEventListener("storage", callback);

  return () => {
    window.removeEventListener(AUTH_TOKEN_CHANGED_EVENT, callback);
    window.removeEventListener("focus", callback);
    window.removeEventListener("pageshow", callback);
    window.removeEventListener("storage", callback);
  };
}

function getSnapshot() {
  return getCookie("token");
}

function getServerSnapshot() {
  return null;
}

export default function useAuthToken() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
